import React from 'react';
import { Colors, Text } from 'library';
import { Link } from 'react-router-dom';

import ThanksForFeedback from '../components/ThanksForFeedback';
import { MainContainer, TextContainer } from '../components/Containers';

export default function DoNotAddPreferredWorkers() {
    return (
        <MainContainer>
            <TextContainer>
                <ThanksForFeedback />
            </TextContainer>
            <TextContainer>
                <Text variant="body1">No updates have been made to your preferred workers list.</Text>
            </TextContainer>
            <TextContainer>
                <Link to="/home" style={{ color: Colors.darkNavy, textDecoration: 'underline', fontWeight: 'bold' }}>
                    Back home
                </Link>
            </TextContainer>
        </MainContainer>
    );
}
